import { render, staticRenderFns } from "./SlotCounterStationDiscountSheet.vue?vue&type=template&id=7fb47655&scoped=true&"
import script from "./SlotCounterStationDiscountSheet.vue?vue&type=script&lang=js&"
export * from "./SlotCounterStationDiscountSheet.vue?vue&type=script&lang=js&"
import style0 from "./SlotCounterStationDiscountSheet.vue?vue&type=style&index=0&id=7fb47655&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb47655",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fb47655')) {
      api.createRecord('7fb47655', component.options)
    } else {
      api.reload('7fb47655', component.options)
    }
    module.hot.accept("./SlotCounterStationDiscountSheet.vue?vue&type=template&id=7fb47655&scoped=true&", function () {
      api.rerender('7fb47655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Counter/SlotCounterStationDiscountSheet.vue"
export default component.exports